import { ReactNode } from 'react'

import Link from '@atoms/Link'

import * as style from './style.module.sass'

type JumpLinkProps = {
  to: string
  children: ReactNode
}
const JumpLink = ({ to, children }: JumpLinkProps) => (
  <Link to={to} className={style.jump}>
    <span>{children}</span>
  </Link>
)

export default JumpLink
